export const TwoPlayer = "Two Player"
export const Greedy = "Machine Greedy"
export const Random = "Machine Random"
export const Rules = "Machine Rules"